const genId = () => Math.random().toString(36).substring(2, 10) + Date.now().toString(36);

// ─── Block Type Definitions ───
export const BLOCK_TYPES = [
  { type: 'header', label: 'Intestazione', icon: 'LayoutTemplate', description: 'Logo, titolo e sottotitolo' },
  { type: 'text', label: 'Testo', icon: 'Type', description: 'Paragrafo di testo' },
  { type: 'image', label: 'Immagine', icon: 'Image', description: 'Immagine con didascalia' },
  { type: 'button', label: 'Bottone', icon: 'MousePointerClick', description: 'Call to action' },
  { type: 'separator', label: 'Separatore', icon: 'Minus', description: 'Linea o spazio' },
  { type: 'columns', label: 'Colonne', icon: 'Columns2', description: 'Due colonne affiancate' },
];

// ─── Default Data per Tipo ───
export const getDefaultBlockData = (type) => {
  switch (type) {
    case 'header':
      return { title: 'Titolo Newsletter', subtitle: 'Sottotitolo descrittivo', bgColor: '#8b5cf6', textColor: '#ffffff', showLogo: false, logoUrl: '' };
    case 'text':
      return { content: 'Scrivi qui il tuo testo...', align: 'left', fontSize: '16' };
    case 'image':
      return { src: '', alt: 'Descrizione immagine', width: '100', align: 'center', caption: '' };
    case 'button':
      return { text: 'Scopri di Più', url: '#', bgColor: '#8b5cf6', textColor: '#ffffff', align: 'center', borderRadius: '8' };
    case 'separator':
      return { style: 'line', height: '1', color: '#e5e7eb', spacing: '20' };
    case 'columns':
      return { leftContent: 'Contenuto colonna sinistra', rightContent: 'Contenuto colonna destra', ratio: '50-50' };
    default:
      return {};
  }
};

export const createBlock = (type) => ({
  id: genId(),
  type,
  data: getDefaultBlockData(type),
});

// ─── HTML Generation ───
const escapeHtml = (str) => (str || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

const blockToHtml = (block) => {
  const { type, data } = block;
  switch (type) {
    case 'header':
      return `<div style="background: ${data.bgColor}; padding: 40px 30px; text-align: center; border-radius: 12px 12px 0 0;">
  ${data.showLogo && data.logoUrl ? `<img src="${data.logoUrl}" alt="Logo" style="max-height: 60px; margin-bottom: 16px;" />` : ''}
  <h1 style="color: ${data.textColor}; margin: 0; font-size: 28px; font-weight: 700;">${escapeHtml(data.title)}</h1>
  ${data.subtitle ? `<p style="color: ${data.textColor}; opacity: 0.9; margin: 10px 0 0; font-size: 16px;">${escapeHtml(data.subtitle)}</p>` : ''}
</div>`;

    case 'text':
      return `<div style="padding: 20px 30px; text-align: ${data.align};">
  <p style="color: #444; line-height: 1.7; font-size: ${data.fontSize}px; margin: 0;">${data.content}</p>
</div>`;

    case 'image':
      return `<div style="padding: 10px 30px; text-align: ${data.align};">
  ${data.src ? `<img src="${data.src}" alt="${escapeHtml(data.alt)}" style="max-width: ${data.width}%; height: auto; border-radius: 8px;" />` : '<div style="background: #f3f4f6; height: 120px; border-radius: 8px; display: flex; align-items: center; justify-content: center; color: #9ca3af;">Inserisci URL immagine</div>'}
  ${data.caption ? `<p style="color: #888; font-size: 13px; margin-top: 8px;">${escapeHtml(data.caption)}</p>` : ''}
</div>`;

    case 'button':
      return `<div style="padding: 20px 30px; text-align: ${data.align};">
  <a href="${data.url}" style="background: ${data.bgColor}; color: ${data.textColor}; padding: 14px 32px; border-radius: ${data.borderRadius}px; text-decoration: none; font-weight: 600; display: inline-block; font-size: 16px;">${escapeHtml(data.text)}</a>
</div>`;

    case 'separator':
      return data.style === 'line'
        ? `<div style="padding: ${data.spacing}px 30px;"><hr style="border: none; border-top: ${data.height}px solid ${data.color}; margin: 0;" /></div>`
        : `<div style="height: ${data.spacing}px;"></div>`;

    case 'columns':
      return `<div style="padding: 10px 30px;">
  <table width="100%" cellpadding="0" cellspacing="0" style="border-collapse: collapse;">
    <tr>
      <td style="width: ${data.ratio === '60-40' ? '60' : data.ratio === '40-60' ? '40' : '50'}%; vertical-align: top; padding-right: 12px;">
        <p style="color: #444; line-height: 1.7; margin: 0;">${data.leftContent}</p>
      </td>
      <td style="width: ${data.ratio === '60-40' ? '40' : data.ratio === '40-60' ? '60' : '50'}%; vertical-align: top; padding-left: 12px;">
        <p style="color: #444; line-height: 1.7; margin: 0;">${data.rightContent}</p>
      </td>
    </tr>
  </table>
</div>`;

    default:
      return '';
  }
};

export const blocksToHtml = (blocks) => {
  const inner = blocks.map(blockToHtml).join('\n');
  return `<div style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; max-width: 600px; margin: 0 auto; background: #ffffff; border-radius: 12px; overflow: hidden; border: 1px solid #e5e7eb;">
${inner}
<div style="padding: 20px 30px; text-align: center; background: #fafafa; border-top: 1px solid #eee;">
  <p style="color: #999; font-size: 12px; margin: 0;">Ricevi questa email perché sei cliente del nostro salone.</p>
</div>
</div>`;
};

// ─── Preset Templates (as blocks) ───
export const PRESETS = [
  {
    id: 'promo_beauty',
    name: 'Promozione Salone',
    preview: 'Offerta speciale per i nostri clienti',
    blocks: [
      { id: 'p1-h', type: 'header', data: { title: 'Offerta Speciale', subtitle: 'Solo per te, i nostri clienti speciali', bgColor: '#ec4899', textColor: '#ffffff', showLogo: false, logoUrl: '' } },
      { id: 'p1-t', type: 'text', data: { content: 'Ciao {nome}! Questa settimana abbiamo preparato un\'offerta esclusiva per te. Vieni a trovarci in salone e scopri tutti i nostri nuovi trattamenti!', align: 'left', fontSize: '16' } },
      { id: 'p1-b', type: 'button', data: { text: 'Prenota Ora', url: '#', bgColor: '#8b5cf6', textColor: '#ffffff', align: 'center', borderRadius: '8' } },
    ]
  },
  {
    id: 'seasonal',
    name: 'Stagionale',
    preview: 'Novità e trend della stagione',
    blocks: [
      { id: 'p2-h', type: 'header', data: { title: 'Novità di Stagione', subtitle: 'I trend che non puoi perdere', bgColor: '#10b981', textColor: '#ffffff', showLogo: false, logoUrl: '' } },
      { id: 'p2-t', type: 'text', data: { content: 'Ciao {nome}! La nuova stagione porta con sé tante novità! Scopri i nuovi tagli, colori e trattamenti che abbiamo preparato per te.', align: 'left', fontSize: '16' } },
      { id: 'p2-c', type: 'columns', data: { leftContent: '<strong>I nostri servizi:</strong><br/>Nuovo trattamento rigenerante<br/>Colori tendenza stagione', rightContent: '<strong>Offerte:</strong><br/>Pacchetto benessere completo<br/>Sconto del 20% su colore', ratio: '50-50' } },
      { id: 'p2-b', type: 'button', data: { text: 'Scopri di Più', url: '#', bgColor: '#10b981', textColor: '#ffffff', align: 'center', borderRadius: '8' } },
    ]
  },
  {
    id: 'minimal',
    name: 'Minimale',
    preview: 'Template semplice ed elegante',
    blocks: [
      { id: 'p3-t', type: 'text', data: { content: 'Ciao {nome},', align: 'left', fontSize: '18' } },
      { id: 'p3-t2', type: 'text', data: { content: 'Scrivi qui il contenuto della tua newsletter. Puoi personalizzare ogni aspetto di questo template.', align: 'left', fontSize: '16' } },
      { id: 'p3-s', type: 'separator', data: { style: 'line', height: '1', color: '#e5e7eb', spacing: '20' } },
      { id: 'p3-t3', type: 'text', data: { content: 'Il tuo salone di fiducia', align: 'center', fontSize: '14' } },
    ]
  },
];
